module.exports = __webpack_public_path__ + "static/media/swirepay-newlogo.b8a02dfd.svg";